import { createGtm } from '@gtm-support/vue-gtm'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig()

  const isBroker = (() => {
    if (import.meta.server) return
    const query = !!useRoute().query.brokerToken
    const session = sessionStorage.getItem('headers')?.includes('brokerToken')
    return query || session
  })()
  if (!config?.public?.gtmIds?.length || isBroker) return

  // Need to be added to prevent storage of personal data in GTM when cookiebot is active
  if (import.meta.client) {
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 3000,
    })
    gtag('set', 'ads_data_redaction', true)
    gtag('set', 'url_passthrough', false)

    // Need to be added here on client after default
    config.public?.cookiebotId && useHead({
      script: [
        {
          'id': 'Cookiebot',
          'src': 'https://consent.cookiebot.com/uc.js',
          'data-cbid': config.public.cookiebotId,
          'async': true,
          'type': 'text/javascript',
          'crossorigin': false,
        },
      ],
    })
  }

  const gtmPlugin = createGtm({
    id: config.public.gtmIds,
    defer: true,
    compatibility: true,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: useRouter(),
    trackOnNextTick: false,
  })
  vueApp.use(gtmPlugin)
})
